_                 = require('underscore')
oldScrollFunction = null
isIE              = false
resizeObject      = null

module.exports = require('../abstract').extend
  template: require('./index.pug')

  methods:

    onWindowScroll: (event) ->
      oldScrollFunction(event) if _.isFunction(oldScrollFunction)

      data = { scrollTop: window.pageYOffset, scrollLeft: window.pageXOffset }
      @.$store.dispatch('window/updateScroll', data)
      @.$emit('scroll', data)

      # if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
      #     alert("you're at the bottom of the page");
      # }

    onWindowResize: ->
      data = { width: resizeObject.clientWidth, height: resizeObject.clientHeight }
      @.$store.dispatch('window/updateClientWidthHeight', data)
      @.$emit('resize', data)

    addResizeHandler: ->
      resizeObject.contentDocument.defaultView.addEventListener('resize', @onWindowResize) if resizeObject?

  created: ->
    # scrolling
    oldScrollFunction = window.onscroll
    window.onscroll   = @onWindowScroll

  mounted: ->
    # resizing
    isIE          = navigator.userAgent.match(/Trident/) == 'Trident'
    resizeObject  = document.createElement('object')

    resizeObject.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;')

    resizeObject.onload = @addResizeHandler
    resizeObject.type   = 'text/html'

    @.$el.appendChild(resizeObject) if isIE
    resizeObject.data = 'about:blank'
    @.$el.appendChild(resizeObject) if !isIE

    @onWindowResize()

  beforeDestroy: ->
    # scrolling
    window.onscroll   = oldScrollFunction
    oldScrollFunction = null

    # resizing
    if resizeObject && resizeObject.onload
      if resizeObject.contentDocument
        resizeObject.contentDocument.defaultView.removeEventListener('resize', @onWindowResize)
      delete resizeObject.onload



// WEBPACK FOOTER //
// ./assets/js/shared/components/window_listener/index.coffee